/* eslint-disable no-unused-vars */
/* global G */
import { curry } from 'lib/util'
import redirectSequence from '@gaia/sequence/module/adapter/router/redirect'
import session, { settings } from 'app/_shared/session'
import routeComposition from 'trait/composition/route'

/**
 * Delete Account Event Handler
 *
 * It redirects to external action, if user is external. Otherwise, sends the corresponding
 * AdminNotice.
 *
 * @type {Gaia.AppModule.EventHandler}
 */
const deleteAccount = async (module, component, event) => {
  const moduleState = module[G.STATE]
  const { route, externalRoute } = component[G.CONFIGURATION]
  const user = session(module).user.ref()

  const { remoteAuthentication, custom } = user.value

  moduleState[G.ROUTE] = (remoteAuthentication || custom) && settings.externalPortalUrl
    ? routeComposition(externalRoute.module, externalRoute.action)
    : routeComposition(route.module, route.action)

  await redirectSequence(module)()
}

export default curry(deleteAccount)
